// extracted by mini-css-extract-plugin
export var contrastLow = "_30-1";
export var externalLink = "_30-2";
export var externalLinkIcon = "_30-3";
export var link = "_30-0";
export var linkLabel = "_30-4";